/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import Urzad from './Urzad';
import ServicesLayout from '../../components/ServicesLayout';

const MainRoute = {
  path: '/',
  action(ctx) {
    return {
      title: 'Lista zarejestrowanych urzędów - e-spdp.pl',
      component: (
        <ServicesLayout>
          <Urzad title="Urząd" />
        </ServicesLayout>
      ),
      description: 'Lista zarejestrowanych urzędów - e-spdp.pl',
    };
  },
};
/* eslint-disable global-require*/
export default {
  path: '/urzad',
  children: [MainRoute, require('./szczegolyUrzedu').default],
};



// WEBPACK FOOTER //
// src/routes/urzad/index.js